import { getCurrentApi } from './baseAPI';

/**
 * Liquidity Threshold API
 * 
 * Endpoints for getting/setting the dynamic liquidation threshold.
 * All calls go through the public-interface gateway.
 */
export const liquidityThresholdAPI = {
  /**
   * Get the current liquidation threshold and its source.
   * GET /admin-api/v1/settings/liquidity-threshold
   */
  get: async () => {
    const api = await getCurrentApi();
    const response = await api.get('/settings/liquidity-threshold');
    return response;
  },

  /**
   * Set a dynamic liquidation threshold (overrides .env value).
   * POST /admin-api/v1/settings/liquidity-threshold
   * @param {number} threshold - Value between 1 and 100
   */
  set: async (threshold) => {
    const api = await getCurrentApi();
    const response = await api.post('/settings/liquidity-threshold', { threshold });
    return response;
  },

  /**
   * Reset the liquidation threshold to the .env default.
   * POST /admin-api/v1/settings/liquidity-threshold/reset
   */
  reset: async () => {
    const api = await getCurrentApi();
    const response = await api.post('/settings/liquidity-threshold/reset');
    return response;
  }
};

export default liquidityThresholdAPI;
